module.exports = __webpack_public_path__ + "static/media/Right legs15.32559d4f.png";